import { node } from "prop-types";
import { useArchivedProjectStore, useStores, useWorkspaceWebsocket } from "@hooks";
import { CoreCommands, ProjectCommands } from "@client";
import { getProjectDetailsQuery } from "@query";
import { PROJECT_STATUS } from "@utils";
import { ArchivedProjectsSocketContext } from "./ArchivedProjectsSocketContext";

export const ArchivedProjectsSocketProvider = ({ children }) => {
  
  const { userStore } = useStores();
  const store = useArchivedProjectStore();

  const {
    socket,
    sendAction,
    socketInitialized,
    setupWorkspaceEvents,
  } = useWorkspaceWebsocket();
  
  const setupArchivedProjectsEvents = (on) => {
    if(!on) {
      socket.current.removeAllListeners();
      setupWorkspaceEvents(true);
      return;
    }
    
    socket.current.on(ProjectCommands.PROJECT_REMOVE, onProjectRemove);
    socket.current.on(ProjectCommands.PROJECT_ARCHIVE, onProjectArchive);
    socket.current.on(ProjectCommands.PROJECT_STATUS, onProjectStatusUpdate);
  }
  
  const joinArchivedProjects = () => {
    setupArchivedProjectsEvents(true);
    socket.current.emit(CoreCommands.JOIN_WORKSPACE_PROJECTS, {
      companyId: userStore.companyId,
      workspaceUuid: userStore.workspaceUuid,
      userId: userStore.data.id,
      userUuid: userStore.data.uuid,
      name: userStore.data.fullname,
      email: userStore.data.email,
    });
  };
  const leaveArchivedProjects = () => {
    setupArchivedProjectsEvents(false);
    socket.current.emit(CoreCommands.LEAVE_WORKSPACE_PROJECTS);
  };
  
  const onProjectArchive = async ({ projectUuid }) => {
    const projectData = await getProjectDetailsQuery(projectUuid);
    store.addNewlyArchivedProject(projectData);
  }
  
  const onProjectRemove = ({ projectUuid }) => {
    store.removeArchivedProject(projectUuid);
  }
  
  const onProjectStatusUpdate = async ({ projectUuid, status }) => {
    if(status !== PROJECT_STATUS.ARCHIVE)
      store.removeArchivedProject(projectUuid);
  }
  
  // --------- USER ACTIONS ---------
  
  const requestProjectRemove = (projectUuid) => {
    sendAction(ProjectCommands.PROJECT_REMOVE, { projectUuid });
  };
  
  const requestProjectStatusChange = (projectUuid, status, order, sourceStatus, sourceOrder) => {
    sendAction(ProjectCommands.PROJECT_STATUS, { projectUuid, status, order, sourceStatus, sourceOrder });
  };
  
  const value = {
    socketInitialized,
    joinArchivedProjects,
    leaveArchivedProjects,
    
    requestProjectRemove,
    requestProjectStatusChange,
  };

  return (
    <ArchivedProjectsSocketContext.Provider value={value}>
      {children}
    </ArchivedProjectsSocketContext.Provider>
  );
};

ArchivedProjectsSocketProvider.propTypes = {
  children: node.isRequired,
};
